// The only camera-to-rendering conversion. Ratios shrink while zooming in.
export const clamp = (x, a, b) => Math.max(a, Math.min(b, x));
export const smoothstep = (a, b, x) => { const t = clamp((x-a)/(b-a),0,1); return t*t*(3-2*t); };
export function semanticZoom(initial, current) {
  return Math.log2(Math.max(Number.EPSILON, initial) / Math.max(Number.EPSILON, current));
}
export function zoomStyle(z, mobile=false, viewportWidth=390) {
  const edgeStart=.8, edgeFull=3.5;
  const compact=mobile?1-smoothstep(320,390,viewportWidth):0;
  const portraitBase=mobile?32-8*compact:36;
  return { z, lod:z<1?"OVERVIEW":z<2.5?"REGIONAL":z<4?"LOCAL":"INSPECTION",
    portraitMix:smoothstep(2.5,3.5,z),
    portraitSize:portraitBase+((mobile?72:80)-portraitBase)*smoothstep(0,6,z),
    portraitGap:6-4*compact*(1-smoothstep(0,4,z)),
    portraitFontMax:mobile?17-3*compact*(1-smoothstep(0,4,z)):18,
    portraitPreviewLead:.45, portraitLimit:mobile?32:64,
    edgeStart, edgeFull, edgeOpacity:.48*smoothstep(edgeStart,edgeFull,z),
    nodeScale:1+.12*clamp(z,-2,5), fogOpacity:1-.10*smoothstep(1,4.5,z),
    fogRadius:Math.min(300,56*2**(clamp(z,-2,8)*.72)),
    labelQuota: Math.min(mobile?95:180,(mobile?4:7)*2**(clamp(z,-2,6)*.95)),
    labelSaturation:smoothstep(mobile?4.4:3.8,mobile?5.6:5,z), fontGrowth:.65*clamp(z,0,5) };
}
export function createSemanticZoom(mobile=()=>false, viewportWidth=()=>typeof window==="undefined"?390:window.innerWidth) {
  let initial=1, camera=null;
  return { attach(c){camera=c;}, setInitial(r){if(Number.isFinite(r)&&r>0)initial=r;},
    focusRatio(r){return Math.min(r, Math.max(initial / 2**3.5, r / 2));},
    value(r=camera?.getState().ratio||initial){return semanticZoom(initial,r);},
    style(r=camera?.getState().ratio||initial){return zoomStyle(semanticZoom(initial,r),mobile(),viewportWidth());},
    sizeRatio(r){return 1/zoomStyle(semanticZoom(initial,r),mobile()).nodeScale;} };
}
